import Cookies from "js-cookie";
import { DeleteNotificationIndexedDB } from "../IndexedDB/notificationIndexedDB";
import {
  AddTabToIndexedDB,
  CheckIndexedDBIsSupport,
  DeleteTabFromIndexedDB,
  GetAllTabsFromIndexedDB,
  GetTabByIdFromIndexedDB,
  RemoveTabFromIndexedDB,
  UpdateTabMerchantIdToIndexedDB,
} from "../IndexedDB/tabIndexedDB";
import { CheckBroadcastIsSupport } from "../broadcastChannel/tabChannel";
import { CheckStatusSocket, SocketConnect } from "./notificationHelper";

const sessionStorageTabIdKey = "tabId";
const masterNotificationTabIdKey = "masterNotificationTab";

export const GetTabIdFromSessionStorage = () => {
  let tabId = sessionStorage.getItem(sessionStorageTabIdKey);
  return tabId ? parseInt(tabId) : null;
};

const SetTabIdFromSessionStorage = (tabId) => {
  sessionStorage.setItem(sessionStorageTabIdKey, tabId);
};

const GetMasterNotificationTabFromLocalStorage = () => {
  let masterTabId = Cookies.get(masterNotificationTabIdKey);
  return masterTabId ? parseInt(masterTabId) : null;
};

const SetMasterNotificationTabFromLocalStorage = (tabId) => {
  Cookies.set(masterNotificationTabIdKey, tabId);
};

const RemoveMasterNotificationTabFromLocalStorage = () => {
  Cookies.remove(masterNotificationTabIdKey);
};

const RemoveMasterNotificationTabFromSessionStorage = () => {
  sessionStorage.removeItem(sessionStorageTabIdKey);
};

export const IsMasterTab = () => {
  if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
    let tabId = GetTabIdFromSessionStorage();
    let masterTabId = GetMasterNotificationTabFromLocalStorage();
    return masterTabId == tabId;
  } else {
    return true;
  }
};
export const IsMasterTabAvailable = () => {
  let masterTabId = GetMasterNotificationTabFromLocalStorage();
  return masterTabId > 0;
};

export const ClearTabFromSessionStorage = () => {
  RemoveMasterNotificationTabFromSessionStorage();
};
export const ClearTabFromLocalStorage = () => {
  RemoveMasterNotificationTabFromLocalStorage();
};
export const SetMasterTab = () => {
  let tabId = GetTabIdFromSessionStorage();
  if (!IsMasterTabAvailable()) {
    SetMasterBase(tabId);
  }
};

const SetTabID = (tabId) => {
  SetTabIdFromSessionStorage(tabId);
};

const SetMasterBase = (tabId) => {
  SetMasterNotificationTabFromLocalStorage(tabId);
  CheckStatusSocket();
};

export const InsertTabIdToTabDB = async () => {
  let tabId = await AddTabToIndexedDB();
  if (tabId > 0) {
    SetTabID(tabId);
    SetMasterTab();
    SocketConnect();
  }
};

export const UpdateTabMerchantId = async (merchantId) => {
  let tabId = GetTabIdFromSessionStorage();
  if (tabId) {
    await UpdateTabMerchantIdToIndexedDB(tabId, merchantId);
  }
};

export const ClearTabDB = async () => {
  let tabs = await GetAllTabsFromIndexedDB();
  if (!tabs || tabs.length == 0) {
    await DeleteTabFromIndexedDB();
    await DeleteNotificationIndexedDB();
  }
};

export const RemoveTabDB = async (tabId) => {
  await RemoveTabFromIndexedDB(tabId);
};

export const GetAllTabs = async () => {
  return await GetAllTabsFromIndexedDB();
};

export const GetTabById = async (tabId) => {
  return await GetTabByIdFromIndexedDB(tabId);
};
